import { render, staticRenderFns } from "./NautaMigration.vue?vue&type=template&id=7980231d&scoped=true"
import script from "./NautaMigration.vue?vue&type=script&lang=js"
export * from "./NautaMigration.vue?vue&type=script&lang=js"
import style0 from "./NautaMigration.vue?vue&type=style&index=0&id=7980231d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7980231d",
  null
  
)

export default component.exports